import { render, staticRenderFns } from "./PaginatedReportDetail.vue?vue&type=template&id=3c2e7f76"
import script from "./PaginatedReportDetail.vue?vue&type=script&lang=js"
export * from "./PaginatedReportDetail.vue?vue&type=script&lang=js"
import style0 from "./PaginatedReportDetail.vue?vue&type=style&index=0&id=3c2e7f76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports